import { render, staticRenderFns } from "./MixArticleLoading.vue?vue&type=template&id=19d9d7cb&"
import script from "./MixArticleLoading.vue?vue&type=script&lang=js&"
export * from "./MixArticleLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports